<template>
  <div id="onlineClip" class="online-clip">
    <div class="online-clip-dialog">
      <div class="dialog-header">
        <span class="dialog-header-title">在线剪辑</span>
        <el-tooltip
          placement="bottom"
          content="*视频的实际长度以视频轨道长度为准"
        >
          <i class="el-icon-question search-tips"></i>
        </el-tooltip>
        <span class="dialog-header-text">
          广告位：{{ spaceInfo.spaceName }}， 分辨率：{{ spaceInfo.resolution }}
        </span>
        <span style="float:right">
          <i class="el-icon-close" @click="handleGoBack"></i>
        </span>
      </div>
      <el-row class="main-area">
        <el-col :span="15" class="material-cols" ref="tabsCol">
          <el-row class="material-area">
            <el-tabs v-model="onlineTab" class="online-clip-tabs">
              <el-tab-pane name="backImageTab">
                <span slot="label"
                  ><i class="el-icon-picture-outline-round"></i> 已选背景</span
                >
                <BackImageTab
                  v-if="onlineTab === 'backImageTab'"
                  ref="backImageTab"
                  @icon-add="handleIconAdd"
                  :spaceInfo="spaceInfo"
                ></BackImageTab>
              </el-tab-pane>
              <el-tab-pane name="materialTab">
                <span slot="label"
                  ><i class="el-icon-folder-opened"></i> 已选视频</span
                >
                <div v-if="addedMaterialList.length === 0" class="empty-text">
                  <span>暂无视频</span>
                </div>
                <template v-else>
                  <div class="material-container">
                    <Draggable
                      :list="addedMaterialList"
                      :sort="false"
                      :group="{ name: 'media', pull: 'clone', put: false }"
                      :clone="handleMediaClone"
                      @start="handleMediaStart"
                      @end="handleSelectEnd"
                    >
                      <div
                        v-for="(material, index) in addedMaterialList"
                        :key="material.agentAccountId + index"
                        class="lastest-info"
                        @mouseover="mouseTarget = index"
                        @mouseout="mouseTarget = null"
                      >
                        <video
                          :src="material.resourceUrl"
                          :poster="material.resourceIcon"
                          :ref="'video' + index"
                          muted
                        ></video>
                        <i
                          class="el-icon-delete material-delete"
                          :style="{
                            display: mouseTarget === index ? 'block' : 'none'
                          }"
                          title="删除"
                          @click="handleMaterialDelete(index)"
                        ></i>
                        <i
                          :style="{
                            display: mouseTarget === index ? 'block' : 'none'
                          }"
                          class="el-icon-circle-plus-outline material-add"
                          title="添加"
                          @click="handleSelectAdd(material, index)"
                        ></i>
                        <el-tooltip
                          class="tooltip-style"
                          placement="bottom-start"
                          :content="material.resourceName"
                        >
                          <div class="material-title">
                            <span>{{ material.resourceName }}</span>
                          </div>
                        </el-tooltip>
                      </div>
                    </Draggable>
                  </div>
                </template>
                <div v-if="onlineTab === 'materialTab'" class="methods-area">
                  <div class="methods-button-group">
                    <el-button
                      class="methods-button"
                      @click="handleShowMaterialDialog"
                      >历史上传</el-button
                    >
                    <el-upload
                      class="location-upload"
                      action="#"
                      accept=".mp4,.ts"
                      :http-request="uploadFile"
                      :disabled="isUploading"
                      :show-file-list="false"
                    >
                      <div class="methods-button">
                        <el-button
                          type="primary"
                          :disabled="isUploading"
                          :loading="isUploading"
                          >本地上传</el-button
                        >
                        <!-- <span v-show="!isUploading">本地上传</span>
                        <Loading
                          v-show="isUploading"
                          color="#ff8b00"
                          :type="2"
                        ></Loading> -->
                      </div>
                    </el-upload>
                    <span class="message"> 本地仅支持上传MP4/TS格式视频</span>
                  </div>
                  <!-- 本期不实现 -->
                  <!-- <div class="methods-scan-way">
                    <i class="el-icon-s-fold"></i>
                    <i class="el-icon-menu"></i>
                  </div> -->
                </div>
              </el-tab-pane>
              <el-tab-pane name="pictureTab">
                <span slot="label"
                  ><i class="el-icon-picture-outline"></i> 已选贴图</span
                >
                <PictureTab
                  v-if="onlineTab === 'pictureTab'"
                  ref="pictureTab"
                  :material-list="selectedMaterialList"
                  :back-list="backImageTrackList"
                  @icon-add="handleIconAdd"
                  :spaceInfo="spaceInfo"
                ></PictureTab>
              </el-tab-pane>
              <!-- <el-tab-pane name="textTab">
                <span slot="label">
                  <span class="diy-icon-t">T</span> 字幕
                </span>
                <TextTab
                  v-if="onlineTab === 'textTab'"
                  :material-list="selectedMaterialList"
                  :is-edit="isTextEdit"
                  @icon-add="handleIconAdd"
                  @stop-edit="handleCancelEdit"
                ></TextTab>
              </el-tab-pane> -->
            </el-tabs>
          </el-row>
        </el-col>
        <el-col :span="9" class="video-cols" ref="videoCols">
          <div v-loading="isLoadingVideo" class="video-frame" ref="videoFrame">
            <canvas
              id="canvasBackImage"
              ref="canvasBackImage"
              class="canvas-back-img"
            ></canvas>

            <!-- 先定义的在下层 -->
            <backImageDrr
              v-for="(item, index) in reverseBackImageList"
              :key="
                'backImageDrr' +
                  getReverseIndex(index, reverseBackImageList.length)
              "
              ref="backImageDrr"
              :track-index="getReverseIndex(index, reverseBackImageList.length)"
              :track-list="item"
              :key-code="keyCode"
              :video-play="videoPlay"
              :is-text-edit="isTextEdit"
              @video-pause="handleVideoPause"
              @stop-edit="handleCancelEdit"
            ></backImageDrr>
            <videoDrr
              v-for="(item, index) in reverseVideoList"
              :key="
                'videoDrr' + getReverseIndex(index, reverseVideoList.length)
              "
              ref="videoDrr"
              :track-index="getReverseIndex(index, reverseVideoList.length)"
              :track-list="item"
              :key-code="keyCode"
              :video-play="videoPlay"
              :is-text-edit="isTextEdit"
            ></videoDrr>
            <pictureDrr
              v-for="(item, index) in reversePictureList"
              :key="
                'pictureDrr' + getReverseIndex(index, reversePictureList.length)
              "
              :id="'pictureDrr' + getReverseIndex(index, reversePictureList.length)"
              ref="pictureDrr"
              :track-index="getReverseIndex(index, reversePictureList.length)"
              :track-list="item"
              :key-code="keyCode"
              :video-play="videoPlay"
              :is-text-edit="isTextEdit"
              @video-pause="handleVideoPause"
              @stop-edit="handleCancelEdit"
            ></pictureDrr>
            <textDrr
              v-for="(item, index) in reverseTextList"
              :key="'textDrr' + getReverseIndex(index, reverseTextList.length)"
              ref="textDrr"
              :id="'textDrr' + getReverseIndex(index, reverseTextList.length)"
              :track-index="getReverseIndex(index, reverseTextList.length)"
              :track-list="item"
              :key-code="keyCode"
              :video-play="videoPlay"
              :is-text-edit="isTextEdit"
              @text-edit="handleTextEdidState"
              @video-pause="handleVideoPause"
              @stop-edit="handleCancelEdit"
            ></textDrr>
          </div>
          <div class="video-controls">
            <div class="controls-icons">
              <el-image
                v-if="!videoPlay"
                class="controls-play"
                :src="controlsIcons.play"
                @click="handleVideoPlay"
              ></el-image>
              <el-image
                v-if="videoPlay"
                class="controls-pause"
                :src="controlsIcons.pause"
                @click="handleVideoPause"
              ></el-image>
            </div>
            <div class="controls-duration">
              {{ trackCurrentTime }} / {{ trackDurationString }}
            </div>
          </div>
        </el-col>
      </el-row>
      <el-row class="operations-area">
        <div class="operations-convenient">
          <i
            :class="{
              'el-icon-delete': true,
              'icon-ban': !selected.type
            }"
            @click="keyUpMonitor({ keyCode: 46 })"
          ></i>
        </div>
        <div class="operations-save">
          <el-button class="save-clip" @click="handleSaveOrSubmit(1)"
            >提交剪辑</el-button
          >
        </div>
      </el-row>
      <el-row class="axis-area">
        <el-col :span="1" class="clip-resource-icons" ref="clipResourceIcons">
          <div class="empty-icon" ref="emptyIcon">
            <!-- 用于设置页面样式 -->
          </div>
          <div
            v-for="(item, index) in pictureTrackList"
            :key="'p' + index"
            @mouseover="showPickIndex = 'p' + index"
            @mouseout="showPickIndex = null"
          >
            <span
              class="track-type-icon"
              :style="{
                color: showPickIndex === 'p' + index ? '#ff8b00' : '#606266'
              }"
            >
              <i class="el-icon-picture-outline track-type-icon"></i>
            </span>
            <ul
              v-show="showPickIndex === 'p' + index"
              class="ul-style"
              :style="{
                top: index * 40 + 15 + 'px',
                left: iconWidth + 'px'
              }"
            >
              <li @click="handleTrackAdd(index, 'picture')">
                <i class="el-icon-plus"></i>
                <span> 添加贴图轨</span>
              </li>
              <li @click="handleTrackDelete(index, 'picture')">
                <i class="el-icon-minus"></i>
                <span> 删除贴图轨</span>
              </li>
              <li @click="handleTrackCopy(index, 'picture')">
                <i class="el-icon-copy-document"></i>
                <span> 复制当前贴图轨道</span>
              </li>
            </ul>
          </div>
          <i class="el-icon-picture-outline-round track-type-icon"></i>
          <i class="el-icon-video-camera track-type-icon"></i>
        </el-col>
        <el-col :span="23" ref="clipResource" class="clip-resource">
          <!-- <div class="tracks-container"> -->
          <Pointer
            ref="pointer"
            class="pointer-style"
            :video-play="videoPlay"
            :selected-material-list="selectedMaterialList"
            :selected-picture-list="pictureTrackList"
            :width-range="tracksDuration.material * trackScale"
            @pause-video="handleVideoPause"
            @set-pointer-track="setPointerAndTrack"
            @current-material="judgeVideoSource"
            @current-picture="judgePictureSource"
            @current-text="judgeTextSource"
            @current-transition="judgeTransitionSource"
          ></Pointer>
          <el-row class="time-axis" ref="timeAxis">
            <TimeAxis
              :width="trackDuration * trackScale + 500"
              :duration="tracksDuration.material"
              :scale="trackScale"
              @move-by-axis="changePointerStart"
            ></TimeAxis>
          </el-row>
          <el-row
            v-for="(item, index) in pictureTrackList"
            :key="'pictureTrack' + index"
            :style="{
              width:
                trackDuration * trackScale + 500 > 6000
                  ? trackDuration * trackScale + 500 + 'px'
                  : '6000px'
            }"
          >
            <PictureTrack
              ref="pictureTrack"
              :track-index="index"
              :track-list="item"
              @click-picture="handleTrackClick"
              @mousedown-picture="handleTrackMouseDown"
            ></PictureTrack>
          </el-row>
          <el-row
            v-for="(item, index) in backImageTrackList"
            :key="'backImageTrack' + index"
            :style="{
              width:
                trackDuration * trackScale + 500 > 6000
                  ? trackDuration * trackScale + 500 + 'px'
                  : '6000px'
            }"
          >
            <BackImageTrack
              ref="backImageTrack"
              :track-index="index"
              :track-list="item"
              @click-backImage="handleTrackClick"
              @mousedown-backImage="handleTrackMouseDown"
            ></BackImageTrack>
          </el-row>
          <el-row
            class="video-track"
            id="videoTrack"
            :style="{
              width:
                trackDuration * trackScale + 500 > 6000
                  ? trackDuration * trackScale + 500 + 'px'
                  : '6000px'
            }"
          >
            <Draggable
              group="media"
              class="drag-target"
              ghost-class="drag-ghost"
              :list="selectedMaterialList"
              :animation="300"
              @start="handleSelectedStart"
              @update="handleSelectedSort"
            >
              <div
                v-for="(item, index) in selectedMaterialList"
                :key="index"
                class="track-container"
              >
                <div
                  class="video-images"
                  :id="'clip' + index"
                  :ref="'clip' + index"
                  @click="
                    handleSelectedClick($event, index, 'selectedMaterialList')
                  "
                ></div>
              </div>
            </Draggable>
            <TransitionTrack
              ref="transitionTrack"
              :material-list="selectedMaterialList"
              :is-save-or-submit="isSaveOrSubmit"
            ></TransitionTrack>
          </el-row>

          <!-- </div> -->
        </el-col>
      </el-row>
    </div>
    <el-dialog
      v-if="isShowMaterialAdd"
      title="历史上传-视频"
      width="80%"
      class="add-material-dialog"
      :visible.sync="isShowMaterialAdd"
      :append-to-body="true"
      :modal-append-to-body="true"
    >
      <MaterialRecommendation
        ref="videoSelect"
        :online-clip="true"
        :edit-id="editId"
        :spaceInfo="spaceInfo"
        @del-video="handleDelVideo"
        @select-material="handleAddVideo"
        @close-dialog="isShowMaterialAdd = false"
      ></MaterialRecommendation>
    </el-dialog>
    <SubmitClip
      v-if="isSaveOrSubmit"
      :is-save-or-submit="isSaveOrSubmit"
      :save-or-submit="saveOrSubmit"
      :form-info="videoInfo"
      :spaceId="spaceInfo.spaceId"
      :video-frame="videoFrame"
      :added-material-list="addedMaterialList"
      :selected-material-list="selectedMaterialList"
      :selected-picture-list="pictureTrackList"
      :track-duration-string="trackDurationString"
      :backImageList="backImageTrackList"
      @submit-close="handleSubmitClose"
      @all-close="handleAllClose"
    ></SubmitClip>
  </div>
</template>
<script>
import MaterialRecommendation from '@/views/mediaFactory/media/MaterialRecommendation'
import Draggable from 'vuedraggable'
import TimeAxis from './TimeAxis'
import Pointer from './Pointer'
// import Loading from './Loading'
import SubmitClip from './SubmitClip'
// import TempMessage from './TempMessage'
import PictureTab from './materialTabs/PictureTab'
import PictureTrack from './tracks/PictureTrack'
import TransitionTrack from './tracks/TransitionTrack'
// import TextTab from './materialTabs/TextTab'
// import TextTrack from './tracks/TextTrack'
// import TransitionTrack from './tracks/TransitionTrack'
import pictureDrr from './drrContainers/pictureDrr'
import textDrr from './drrContainers/textDrr'
import backImageDrr from './drrContainers/backImageDrr'
import materialStore from '@/views/mediaFactory/media/store'
import { formatDuration } from '@/utils/smartCreation'
import { mapState } from 'vuex'
import BackImageTab from './materialTabs/BackImageTab'
import BackImageTrack from './tracks/BackImageTrack'
import videoDrr from './drrContainers/videoDrr'
import { commonUploadFile } from '@/views/mediaFactory/utils/upload'
export default {
  components: {
    MaterialRecommendation,
    Draggable,
    TimeAxis,
    Pointer,
    // Loading,
    SubmitClip,
    // TempMessage,
    PictureTab,
    PictureTrack,
    TransitionTrack,
    // TextTab,
    // TextTrack,
    // TransitionTrack,
    pictureDrr,
    textDrr,
    BackImageTab,
    backImageDrr,
    BackImageTrack,
    videoDrr
  },
  props: {
    isShowOnlineClip: {
      type: Boolean,
      default: false
    },
    isChangedCover: {
      type: Boolean,
      default: false
    },
    addedMaterial: {
      type: Array,
      default: function () {}
    },
    editId: {
      type: Number,
      default: null
    },
    spaceInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      clipLoading: false,
      onlineTab: 'backImageTab',
      isShowMaterialAdd: false,
      videoInfo: {
        editId: '',
        videoTitle: '',
        businessType: '',
        categoryId: '',
        categoryName: '',
        tag: ['爱情', '都市', '又爱情', '又都市'],
        picH: '',
        picV: '',
        fileId: '',
        define: '1080P',
        status: '',
        videoType: 0,
        submitTime: '',
        createdTime: '',
        modifyTime: '',
        url: '',
        userId: '',
        duration: 0,
        productType: 0
      },
      isUploading: false,
      fileList: [],
      addedMaterialList: [],
      selectedMaterialList: [],
      editableList: [],
      videoPlay: false,
      controlsIcons: {
        play: require('../../assets/onlineClip/play.png'),
        pause: require('../../assets/onlineClip/pause.png')
      },
      banClip: false,
      isLimit: false,
      trackHeight: '55px',
      trackContainer: undefined,
      trackCurrentTime: '00:00:00',
      trackDurationString: '00:00:00',
      trackDuration: 0,
      tracksDuration: {
        picture: 0,
        material: 0
      },
      sliderData: 0,
      mouseTarget: null,
      videoSrc: '',
      videoBlobs: [],
      videoTarget: undefined,
      isNeedCurrent: false,
      videoCount: 0,
      duration: 0,
      dataURL: '',
      pointerWidth: 0,
      realLeft: 0,
      wholeWidth: 500,
      videoLoaded: false,
      isInputting: false,
      isEdit: false,
      isSaveOrSubmit: false,
      saveOrSubmit: 0,
      titleHeight: 70,
      canvasWidth: 100,
      canvasVideo: null,
      canvasTimer: null,
      canvasBackImage: null,
      tempTransitionList: [],
      pictureCurrentTime: 0,
      resizedPicture: {
        width: 0,
        height: 0,
        zoom: null
      },
      videoFrame: {
        width: null,
        height: null
      },
      keyCode: null,
      loadingImage: require('@/assets/onlineClip/material1004.png'),
      isDeletePicture: false,
      isLoadingVideo: false,
      showUlIndex: null,
      showPickIndex: null,
      isTextEdit: false,
      clipResource: null,
      oldPictureIndex: null,
      iconWidth: 0
    }
  },
  computed: {
    ...mapState({
      selected: state => state.selected,
      selectedTarget: state => state.selectedTarget,
      playingMaterial: state => state.playingMaterial,
      playingPicture: state => state.playingPicture,
      playingPictureIndex: state => state.playingPictureIndex,
      playingText: state => state.playingText,
      playingTextIndex: state => state.playingTextIndex,
      playingTransition: state => state.playingTransition,
      playingBackImage: state => state.playingBackImage,
      playingBackImageIndex: state => state.playingBackImageIndex,
      pointerLeft: state => state.pointerLeft,
      pointerDuration: state => state.pointerDuration,
      textTrackList: state => state.textTrackList,
      pictureTrackList: state => state.pictureTrackList,
      backImageTrackList: state => state.backImageTrackList,
      activeName: state => state.activeName,
      isTrackDrag: state => state.isTrackDrag,
      trackScale: state => state.trackScale,
      videoReource: state => state.videoReource,
      backZoom: state => state.backZoom
    }),
    reverseBackImageList: function () {
      return JSON.parse(JSON.stringify(this.backImageTrackList)).reverse()
    },
    reversePictureList: function () {
      return JSON.parse(JSON.stringify(this.pictureTrackList)).reverse()
    },
    reverseTextList: function () {
      return JSON.parse(JSON.stringify(this.textTrackList)).reverse()
    },
    reverseVideoList: function () {
      return JSON.parse(JSON.stringify(this.videoReource)).reverse()
    }
  },
  watch: {
    pointerDuration: function (val) {
      const selected = this.selectedTarget
      if (!selected) return true
      // 只有视频轨道素材才能使用剪刀裁剪
      if (this.selected.type !== 'selectedMaterialList') {
        this.banClip = true
        return true
      }
      if (val <= selected.trackStartTime || val >= selected.trackEndTime) {
        this.banClip = true
      } else {
        this.banClip = false
      }
      // 视频在播放中因转场换源加载原因暂停时
      if (this.videoTarget.paused && this.videoPlay) {
        this.handleVideoPlay()
      }
    },
    selectedTarget: function (val) {
      // 无选择块 不可剪辑
      if (!this.selected.type) {
        this.banClip = true
        return true
      }
      // 贴图 不可剪辑
      if (this.selected.type === 'pictureTrackList') {
        this.banClip = true
        return true
      }
      const pointerDuration = this.pointerDuration
      if (
        pointerDuration <= val.trackStartTime ||
        pointerDuration >= val.trackEndTime
      ) {
        this.banClip = true
      } else {
        this.banClip = false
      }
    },
    addedMaterialList: function (val) {
      this.$nextTick(() => {
        this.getMaterialLoad(val)
      })
    },
    selectedMaterialList: function (val, oldValue) {
      // 等数据更新了再取last
      this.$nextTick(() => {
        const last = val.length > 0 ? val[val.length - 1].trackEndTime : 0
        if (last === undefined) {
          return true
        }
        this.tracksDuration.material = last
        this.judgeTrackDuration()
      })
    },
    playingPicture: function (val) {
      // 避免视频贴图的卡顿以及不同视频贴图切换时所导致的骤停报错问题
      if (this.oldPictureIndex === this.playingPictureIndex[0]) {
        return true
      }
      if (val[0] && val[0].fileType === 'video') {
        // if (this.videoPlay) {
        //   this.playVideoPicture(val[0], true)
        // } else {
        //   this.playVideoPicture(val[0], false)
        // }
      }
    },
    playingTransition: function (val) {
      // let videoTransition = this.$refs.videoTransition
      // if (!val) {
      //   videoTransition.src = ''
      //   return true
      // }
      // if (this.videoPlay && val && val.transitionMaterialUrl) {
      //   setTimeout(() => {
      //     videoTransition.src = val.transitionMaterialUrl
      //     videoTransition.playbackRate = val.playbackRate
      //     videoTransition.currentTime = (this.pointerDuration - val.trackStartTime) * val.playbackRate
      //     videoTransition.play()
      //   }, 150)
      // }
    },
    reverseBackImageList(newValue, oldValue) {
      this.drawBackImage(newValue)
    }
  },
  methods: {
    // 关闭在线剪辑页面
    handleOnclipClose() {
      if (this.selectedMaterialList.length || this.editId) {
        this.$confirm('请注意保存，否则关闭后所有操作将会清除。', '提示', {
          confirmButtonText: '确定关闭',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.commit('clearAll')
          this.$emit('online-clip-close')
          if (this.editId) {
            this.$emit('clear-edit-id')
          }
        })
      } else {
        this.$emit('online-clip-close')
      }
    },
    // 拖拽深拷贝
    handleMediaClone(e) {
      return { ...e }
    },
    handleMediaStart(e) {
      // const duration = this.trackDuration
      if (this.selectedMaterialList.length > 1) {
        this.$message('视频轨道已有素材，请清空轨道后再操作')
        return true
      }
      const material = this.addedMaterialList[e.oldIndex]
      if (material.resourceIcon.indexOf('material1004') !== -1) {
        this.$message('素材加载中，右侧预览加载完毕后方可添加')
        this.isLimit = true
        return false
      }
    },
    // 拖拽添加素材结束
    handleSelectEnd(e) {
      if (e.from === e.to) {
        return false
      }
      if (this.isLimit) {
        this.selectedMaterialList.splice(0, 1)
        this.isLimit = false
        return false
      }
      if (this.selectedMaterialList.length > 1) {
        this.$message('视频轨道已有素材，请清空轨道后再操作')
        this.selectedMaterialList = this.selectedMaterialList.slice(0, 1)
        return true
      }
      // this.videoCount += 1
      this.videoCount = 1
      const targetIndex = 0
      const indexCount = 0

      let selectedMaterialList = this.selectedMaterialList
      let selectedMaterial = this.selectedMaterialList[targetIndex]
      const duration = selectedMaterial.duration
      let target = ''
      this.selected.duration = duration
      this.wholeWidth += duration * this.trackScale
      this.trackContainer.style.width = this.wholeWidth + 'px'
      // 添加在末尾
      if (targetIndex === indexCount) {
        target = document.getElementById('clip' + targetIndex)
      } else {
        for (let i = indexCount; i > targetIndex; i--) {
          let before = document.getElementById('clip' + (i - 1))
          let after = document.getElementById('clip' + i)
          this.updateStyle(before, after)
          this.updateTime(i, duration, 1)
        }
        target = document.getElementById('clip' + targetIndex)
      }
      target.style.width = duration * this.trackScale + 'px'
      target.style.height = this.trackHeight
      target.style.backgroundImage = 'url(' + selectedMaterial.resourceIcon + ')'
      target.style.backgroundSize = 'auto 100%'

      if (targetIndex === 0) {
        selectedMaterial.trackStartTime = 0
      } else {
        selectedMaterial.trackStartTime =
          selectedMaterialList[targetIndex - 1].trackEndTime
      }
      selectedMaterial.trackEndTime = selectedMaterial.trackStartTime + duration
      selectedMaterial.startTime = selectedMaterial.startFrame
      selectedMaterial.endTime = selectedMaterial.endFrame
      if (this.videoCount === 1) {
        this.videoSrc = selectedMaterial.resourceUrl
      }
      this.tracksDuration.material = this.selectedMaterialList[
        this.selectedMaterialList.length - 1
      ].trackEndTime
      this.judgeTrackDuration()
      this.handleSelectedClick(target, targetIndex, 'selectedMaterialList')
      // if (!this.selectedMaterialList[0].width) {
      this.$set(this.selectedMaterialList[0], 'width', (selectedMaterial.width / this.backZoom.width))
      this.$set(this.selectedMaterialList[0], 'height', (selectedMaterial.height / this.backZoom.height))
      this.$set(this.selectedMaterialList[0], 'nowXAxis', 0)
      this.$set(this.selectedMaterialList[0], 'nowYAxis', 0)
      // }
      this.$store.commit('setVideoReource', selectedMaterialList)
      this.$nextTick(() => {
        if (this.$refs.videoDrr) {
          this.videoTarget = this.$refs.videoDrr[0].$refs.drrTarget[0]
          // this.videoTarget.addEventListener('timeupdate',
          //   this.videoTimeUpdateMonitor
          // })
          this.videoTarget.addEventListener(
            'timeupdate',
            this.videoTimeUpdateMonitor
          )
          this.videoTarget.addEventListener('pause', this.stopCanvasVideo)
        }
      })
    },
    handleSelectAdd(material, index) {
      let target = Object.assign({}, material)
      let e = {}
      e.from = 0
      e.to = 1
      e.newIndex = this.videoCount
      e.oldIndex = index
      if (this.backImageTrackList[0].length === 0) {
        this.$message('请先选择背景素材')
        return
      }
      if (this.selectedMaterialList.length > 0 && this.selectedMaterialList[0].resourceId === target.resourceId) {
        this.$message('视频已选用')
        return
      } else {
        this.selectedMaterialList = []
      }
      this.selectedMaterialList.push(target)
      this.$nextTick(() => {
        this.handleMediaStart(e)
        this.handleSelectEnd(e)
      })
    },
    handleMaterialDelete(index) {
      this.addedMaterialList.splice(0, 1)
      this.$store.commit('setVideoReource', [])
      this.handleMediaDelete()
    },
    handleSelectedStart(e) {
      const index = 'clip' + e.oldIndex
      this.handleSelectedClick(
        this.$refs[index][0],
        e.oldIndex,
        'selectedMaterialList'
      )
    },
    // 轨道素材移动
    handleSelectedSort(e) {
      this.handleVideoPause()
      const targetIndex = e.newIndex
      const originalIndex = e.oldIndex
      let moveWidth = 0
      let target = document.getElementById('clip' + targetIndex)
      const originalTarget = document.getElementById('clip' + originalIndex)
      const temp = {
        width: originalTarget.style.width,
        height: originalTarget.style.height,
        backgroundImage: originalTarget.style.backgroundImage
      }
      const moveTrackDuration = this.getDurationByWidth(
        originalTarget.offsetWidth
      )
      if (targetIndex > originalIndex) {
        for (let i = originalIndex; i < targetIndex; i++) {
          let before = document.getElementById('clip' + (i + 1))
          let after = document.getElementById('clip' + i)
          moveWidth += before.offsetWidth
          this.updateStyle(before, after)
          this.updateTime(i, moveTrackDuration, 0)
        }
        const tempWidth = this.getDurationByWidth(moveWidth)
        this.updateTime(targetIndex, tempWidth, 1)
      } else {
        for (let j = originalIndex; j > targetIndex; j--) {
          let before2 = document.getElementById('clip' + (j - 1))
          let after2 = document.getElementById('clip' + j)
          moveWidth += before2.offsetWidth
          this.updateStyle(before2, after2)
          this.updateTime(j, moveTrackDuration, 1)
        }
        const tempWidth = this.getDurationByWidth(moveWidth)
        this.updateTime(targetIndex, tempWidth, 0)
      }
      target.style.width = temp.width
      target.style.height = temp.height
      target.style.backgroundImage = temp.backgroundImage
      target.style.backgroundSize = 'auto 100%'
      this.handleSelectedClick(target, targetIndex, 'selectedMaterialList')
    },
    // 点击轨道素材
    handleSelectedClick(e, index, target, trackIndex) {
      const realList =
        target === 'selectedMaterialList'
          ? this.selectedMaterialList
          : undefined
      this.$store.dispatch('setTrackBlockSelect', {
        e: e,
        index: index,
        trackIndex: trackIndex,
        list: target,
        realList: realList,
        vm: this
      })
    },
    handleShowMaterialDialog() {
      this.isShowMaterialAdd = true
    },
    handleVideoPlayOrPause() {
      if (this.videoPlay) {
        this.handleVideoPause()
      } else {
        this.handleVideoPlay()
      }
    },
    // 播放轨道视频
    handleVideoPlay() {
      // 播放轨道视频
      if (!this.selectedMaterialList.length) {
        this.$message('视频轨道为空，请添加素材至轨道后再尝试播放')
        return false
      }
      if (this.trackDurationString === '00:00:00') {
        return false
      }
      this.videoPlay = true
      setTimeout(() => {
        if (this.videoTarget.src) {
          this.videoTarget.play()
        }
        const drrTarget = this.$refs.pictureDrr[0].$refs.drrTarget
          ? this.$refs.pictureDrr[0].$refs.drrTarget[0]
          : null
        if (drrTarget && this.playingPicture[0].fileType === 'video') {
          drrTarget.currentTime =
            this.pointerDuration - this.playingPicture[0].trackStartTime
          drrTarget.play()
        }
      }, 150)
    },
    // 暂停轨道视频
    handleVideoPause() {
      this.videoPlay = false
      if (this.videoTarget.src) {
        this.videoTarget.pause()
      }
      const drrTarget = this.$refs.pictureDrr[0].$refs.drrTarget
        ? this.$refs.pictureDrr[0].$refs.drrTarget[0]
        : null
      if (drrTarget && this.playingPicture[0].fileType === 'video') {
        // 避免视频贴图播放时暂停后的无法再次播放
        this.oldPictureIndex = null
        drrTarget.pause()
      }
    },
    handleTextEdidState(state) {
      this.isTextEdit = state
    },
    // 保存/提交剪辑
    handleSaveOrSubmit(way) {
      if (this.backImageTrackList[0].length > 0) {
        if (this.selectedMaterialList.length && this.videoReource.length) {
          this.handleVideoPause()
          this.isSaveOrSubmit = true
          this.saveOrSubmit = way
        } else {
          this.$message('轨道无视频素材, 请选取视频素材进行操作再保存')
        }
      } else {
        this.$message('轨道无背景素材, 请选取背景素材进行操作再保存')
      }
    },
    handleMediaDelete() {
      if (this.videoPlay) {
        this.handleVideoPause()
      }
      if (this.videoCount === 0) {
        return false
      }
      const index = this.selected.index
      const count = this.videoCount - 1
      const width = this.selected.width
      const moveDuration = this.getDurationByWidth(width)
      let selectedMaterialList = this.selectedMaterialList
      for (let i = index; i < count; i++) {
        let before = document.getElementById('clip' + (i + 1))
        let after = document.getElementById('clip' + i)
        this.updateStyle(before, after)
        this.updateTime(i + 1, moveDuration, 0)
      }
      selectedMaterialList.splice(index, 1)
      this.videoCount--
      // 轨道无视频
      if (this.videoCount === 0) {
        this.updateData(0, false)
        this.$store.commit('clearSelected')
        this.$store.commit('updatePlayingTarget', {
          target: 'playingMaterial',
          value: {},
          index: undefined
        })
        this.videoSrc = ''
        // 清空画布
        // this.canvasVideo.width = this.videoFrame.width * 2
        // 避免视频加载中时清空轨道后 所导致的加载状态不更新
        this.isLoadingVideo = false
      } else {
        // 轨道还有视频
        const nextMedia =
          selectedMaterialList[index - 1] || selectedMaterialList[index]
        const last = selectedMaterialList[selectedMaterialList.length - 1]
        let targetIndex = index > 0 ? index - 1 : index
        let target =
          document.getElementById('clip' + (index - 1)) ||
          document.getElementById('clip' + index)
        this.videoSrc = nextMedia.resourceUrl
        this.handleSelectedClick(target, targetIndex, 'selectedMaterialList')
        if (this.pointerDuration > last.trackEndTime) {
          this.updateData(last.trackEndTime, false)
        }
        this.$refs.pointer.judgePlayingTarget()
      }
      this.wholeWidth -= width
      this.trackContainer.style.width = this.wholeWidth + 'px'
    },
    handleEditMaterialAdd(material) {
      let target = this.addedMaterialList.find(item => {
        const id = item.coocaaMId === material.coocaaMId
        const start = item.startFrame === material.startFrame
        const end = item.endFrame === material.endFrame
        return id && start && end
      })
      if (target) {
        this.$message('该视频已选用')
        return false
      }
      const black =
        'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCACWAMgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAn/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AJVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//9k='
      if (material.resourceIcon === black) {
        this.$message('该素材暂不支持剪辑')
        return false
      }
      if (!target) {
        const target = Object.assign({}, material)
        target.startTime = target.startFrame
        target.endTime = target.endFrame
        this.addedMaterialList.push(target)
        // this.$message({
        //   message: '素材选用成功，可去【在线剪辑】中剪辑合成',
        //   type: 'success'
        // })
      }
    },
    handleAddVideo(data) {
      if (this.addedMaterialList.some(item => item.md5 === data.md5)) {
        this.$message('视频已选择')
      } else {
        this.addedMaterialList = []
        this.addedMaterialList.push(data)
      }
    },
    handleDelVideo(data) {
      if (this.selectedMaterialList.some(item => item.md5 === data.md5)) {
        this.$message('视频在轨道上，不允许删除')
      } else {
        this.$confirm('确认是否删除', '提示', {
          center: true,
          showClose: false
        }).then(() => {
          this.$service.deleteResource([data.resourceId]).then(res => {
            if (this.addedMaterialList.some(item => item.md5 === data.md5)) {
              this.addedMaterialList.splice(0, 1)
              this.$store.commit('setVideoReource', [])
              this.handleMediaDelete()
            }
            this.$refs.videoSelect.fetchData()
          })
        })
      }
    },

    // 关闭保存/提交剪辑对话框
    handleSubmitClose() {
      this.isSaveOrSubmit = false
    },
    handleAllClose() {
      this.isSaveOrSubmit = false
      this.$store.commit('clearAll')
      materialStore.fileList = []
      materialStore.pictureFileList = []
      materialStore.lastestDownloadList = []
      materialStore.isUploading = false
      materialStore.isPicUploading = false
      this.$emit('go-back')
    },
    handleTrackMouseDown(e, index, trackIndex, name, isNeedTab) {
      if (this.videoPlay) {
        this.handleVideoPause()
      }
      // isNeedTab: 用于区分是否需要激活对应DRR - 在轨道拖拽操作中不必激活
      if (isNeedTab) {
        this.$refs[name + 'Drr'][trackIndex].handleActive(index, true)
      }
      this.handleSelectedClick(e, index, name + 'TrackList', trackIndex)
    },
    handleTrackClick(e, index, trackIndex, target, tabName, active) {
      if (this.videoPlay) {
        this.handleVideoPause()
      }
      const selected = this[target][trackIndex][index]
      this.onlineTab = tabName
      this.$nextTick(() => {
        if (selected.trackStartTime >= this.tracksDuration.material) {
          this.$store.commit('updateDrrActive', null)
          this.handleSelectedClick(e, index, target, trackIndex)
        } else {
          let duration =
            selected.trackStartTime + selected.realRange / this.trackScale / 2
          if (duration > this.tracksDuration.material) {
            duration = this.tracksDuration.material
          }
          this.handleSelectedClick(e, index, target, trackIndex)
          this.updateData(duration, false)
          this.$refs.pointer.judgePlayingTarget()
          this.$store.commit('updateDrrActive', active)
        }
      })
    },
    handleIconAdd(name, target) {
      // 获取playing-
      const targetName = name
      const targetList = name + 'TrackList'
      const playingTarget =
        'playing' + name.slice(0, 1).toUpperCase() + name.slice(1)
      const params = {
        name: targetName,
        list: targetList
      }
      this.$refs.pointer.judgePlaying(params)
      // 获取对应情况下的属性
      const realTarget = Object.assign({}, target)
      // 处理没有初始时长的对象
      if (!realTarget.duration) {
        realTarget.duration = 1
      }
      if (name === 'backImage') {
        realTarget.positionXBegin = 0
        realTarget.positionXEnd = realTarget.duration * this.trackScale
      } else {
        realTarget.positionXBegin = this[playingTarget][0] && this[playingTarget][0].positionXEnd
          ? this[playingTarget][0].positionXEnd
          : this.pointerLeft
        realTarget.positionXEnd = realTarget.positionXBegin + realTarget.duration * this.trackScale
      }
      // 获取对应情况下 pointer现对应的index 用于后续插入与排序
      let newIndex = this[playingTarget + 'Index'][0]
      if (!this[playingTarget][0] || !this[playingTarget][0].positionXEnd) {
        const index = this[targetList][0].reduce((result, item, index) => {
          if (this.pointerLeft >= item.positionXEnd) {
            result = index
          }
          return result
        }, -1)
        newIndex = index
      }
      this.$store.commit('tabDragAdd', {
        target: realTarget,
        index: newIndex,
        targetTrackIndex: 0,
        list: targetList,
        prefix: name,
        trackId: name + 'Track',
        vm: this
      })
    },
    handleCancelEdit(trackIndex) {
      this.$refs.textDrr[trackIndex].handleDrrTextEditEnd()
    },
    handleBlockDelete() {
      if (this.selected.type !== 'selectedMaterialList') {
        this.$store.commit('updateDrrActive', null)
      }
      this.$store.commit('trackBlockDelete', { vm: this })
    },
    handleTrackAdd(index, type) {
      if (this[type + 'TrackList'].length === 5) {
        this.$message('添加失败，该类型轨道条数已达上限')
        return false
      }
      if (type === 'text') {
        this.$store.commit('trackAdd', {
          name: 'text',
          index: index,
          list: 'textTrackList',
          vm: this
        })
      } else {
        this.$store.commit('trackAdd', {
          name: 'picture',
          index: index,
          list: 'pictureTrackList',
          vm: this
        })
      }
    },
    handleTrackDelete(index, type) {
      if (this[type + 'TrackList'].length === 1) {
        this.$message('删除失败，该类型轨道必须存在一条')
        return false
      }
      if (type === 'text') {
        this.$store.commit('trackDelete', {
          name: 'text',
          index: index,
          list: 'textTrackList',
          vm: this
        })
      } else {
        this.$store.commit('trackDelete', {
          name: 'picture',
          index: index,
          list: 'pictureTrackList',
          vm: this
        })
      }
    },
    handleTrackCopy(index, type) {
      if (this[type + 'TrackList'].length === 5) {
        this.$message({
          type: 'warning',
          message: '添加失败，该类型轨道条数已达上限'
        })
        return false
      }
      if (type === 'text') {
        this.$store.commit('trackCopy', {
          name: 'text',
          index: index,
          list: 'textTrackList',
          vm: this
        })
      } else {
        this.$store.commit('trackCopy', {
          name: 'picture',
          index: index,
          list: 'pictureTrackList',
          vm: this
        })
      }
    },
    uploadFile(paramsFile) {
      this.isUploading = true
      const that = this
      let callback = function (e) {
        e.then(res => {
          that.isUploading = false
          if (res.code === 0) {
            const result = {
              duration: res.data.duration,
              format: res.data.format,
              height: res.data.height,
              md5: res.data.md5,
              resourceIcon: res.data.resourceIcon,
              resourceId: res.data.resourceId,
              resourceName: res.data.resourceName,
              resourceType: res.data.resourceType,
              resourceUrl: res.data.resourceUrl,
              size: res.data.size,
              spaceId: res.data.spaceId,
              width: res.data.width,
              startTime: 0,
              startFrame: 0,
              endTime: res.data.duration,
              endFrame: res.data.duration
            }
            that.addedMaterialList = []
            that.addedMaterialList.push(result)
          } else {
            that.$message.error(res.message)
          }
        }).catch((error) => {
          that.isUploading = false
          that.$notify({
            title: '操作失败',
            type: 'error',
            message: error.message
          })
        })
      }
      commonUploadFile(paramsFile, 1, this.spaceInfo.spaceId, callback)
    },
    // 读取指针位置与轨道播放位置
    setPointerAndTrack(left, pointerDuration) {
      this.$store.commit('updatePointer', {
        pointerLeft: left,
        pointerDuration: pointerDuration
      })
      this.trackCurrentTime = formatDuration(pointerDuration)
      if (left === 0) {
        this.judgeVideoSource(this.selectedMaterialList[0])
      }
    },
    // 判断可剪辑范围
    judgeMediaClipStation() {
      const rangeStart = this.selectedTarget.trackStartTime * this.trackScale
      const rangeEnd = this.selectedTarget.trackEndTime * this.trackScale
      const pointerLeft = this.pointerLeft
      this.realLeft = pointerLeft - rangeStart
      if (pointerLeft >= rangeEnd || pointerLeft <= rangeStart) {
        return false
      }
      return true
    },
    // 判断播放源
    judgeVideoSource(playingMaterial) {
      if (!playingMaterial) {
        this.videoSrc = ''
        return false
      }
      const lastPlayedMedia = Object.assign({}, this.playingMaterial)
      let tempLeft = this.pointerDuration - playingMaterial.trackStartTime
      this.$store.commit('updatePlayingTarget', { target: 'playingMaterial', value: playingMaterial, index: undefined })
      // 视频不在播放中, 指针在手动移动时
      if (!this.videoPlay) {
        // console.log('视频不在播放中, 指针在手动移动时')
        this.videoSrc = playingMaterial.resourceUrl
        this.videoTarget.currentTime = (playingMaterial.startTime || 0) + tempLeft
        return 1
      }
      // 视频播放时, 素材改变 需要换源
      const judgeChangeSrc = playingMaterial.resourceUrl !== lastPlayedMedia.resourceUrl
      if (judgeChangeSrc) {
        // console.log('视频播放时, 素材改变 需要换源')
        this.videoSrc = playingMaterial.resourceUrl
        this.videoTarget.src = playingMaterial.resourceUrl
        this.videoTarget.currentTime = (playingMaterial.startTime || 0) + tempLeft
        this.handleVideoPlay()
      }
      // 视频播放时, 素材不变 无需换源
      const judgeChangeCurrentTime = (playingMaterial.resourceUrl === lastPlayedMedia.resourceUrl) && (playingMaterial.trackStartTime !== lastPlayedMedia.trackStartTime)
      if (judgeChangeCurrentTime) {
        // console.log('视频播放时, 素材不变 无需换源')
        this.videoTarget.currentTime = (playingMaterial.startTime || 0) + tempLeft
      }
    },
    judgePictureSource(targetList, indexList) {
      // playingPicture为undefined时: 关闭对应操作页面
      // if (!target) {
      //   this.$store.commit('updateDrrActive', null)
      // }
      // 视频playingPicture没变 并且不在播放中时: 设置当前视频贴图应在的时间并跳转显示
      const last = this.playingPicture[0]
      if (last) {
        const judgeResult =
          targetList[0] &&
          targetList[0].title === last.title &&
          targetList[0].trackStartTime === last.trackStartTime
        // if (!this.videoPlay && judgeResult) {
        //   this.playVideoPicture(targetList[0], false)
        // }
      }
      // playing-改变 重新赋值 并关闭activeDrr及对应操作页
      if (!this.judgePlayingChange('playingPictureIndex', indexList)) {
        this.$store.commit('updateDrrActive', null)
        this.$store.commit('updatePlayingTarget', {
          target: 'playingPicture',
          value: targetList,
          index: indexList
        })
      }
    },
    judgeTextSource(targetList, indexList) {
      // playing-改变 重新赋值 并关闭activeDrr及对应操作页
      if (!this.judgePlayingChange('playingTextIndex', indexList)) {
        this.$store.commit('updateDrrActive', null)
        this.$store.commit('updatePlayingTarget', {
          target: 'playingText',
          value: targetList,
          index: indexList
        })
      }
    },
    judgeTransitionSource(target) {
      this.$store.commit('updatePlayingTarget', {
        target: 'playingTransition',
        value: target,
        index: undefined
      })
    },
    judgePlayingChange(oldList, newList) {
      return JSON.stringify(this[oldList]) === JSON.stringify(newList)
    },
    judgeTrackDuration() {
      let duration = 0
      for (let item in this.tracksDuration) {
        if (this.tracksDuration[item] > duration) {
          duration = this.tracksDuration[item]
        }
      }
      this.trackDuration = duration
      this.trackDurationString = formatDuration(this.tracksDuration.material)
      if (duration === 0) {
        this.updateData(duration, false)
      }
    },
    avoidResizeFail(target, index, name) {
      // 避免伸缩bug
      if (
        target &&
        this.selected.index !== index &&
        this.selected.type === name + 'TrackList'
      ) {
        const target = this.$refs[name + 'Track'][this.selected.trackIndex]
          .$refs[name + index][0]
        this.handleSelectedClick(target, index, name + 'TrackList')
      }
    },
    // playVideoPicture(picture, isNeedPlay) {
    //   this.$nextTick(() => {
    //     let videoPicture = this.$refs.pictureDrr[0].$refs.drrTarget[0]
    //     videoPicture.currentTime = this.pointerDuration - picture.trackStartTime
    //     this.$store.commit('drrElementData', {
    //       way: false,
    //       index: this.playingPictureIndex[0],
    //       playingName: 'playingPicture',
    //       vm: this.$refs.pictureDrr[0]
    //     })
    //     // 需要播放视频贴图
    //     if (isNeedPlay) {
    //       setTimeout(() => {
    //         // 避免异步函数在不允许的条件执行 - 非视频播放时不允许贴图播放
    //         if (this.videoPlay) {
    //           videoPicture.play()
    //         }
    //       }, 150)
    //     }
    //   })
    // },
    changePointerStart(duration) {
      this.handleVideoPause()
      this.updateData(duration, false)
      this.$refs.pointer.judgePlayingTarget()
    },
    getMaterialLoad(addedMaterialList) {
      const black =
        'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCABuAMgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAn/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AJVAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//Z'
      let canvas = document.createElement('canvas')
      canvas.width = 200
      canvas.height = 110
      for (let i = 0; i < addedMaterialList.length; i++) {
        let resourceIcon = addedMaterialList[i].resourceIcon
        if (resourceIcon.indexOf('material1004') === -1) {
          continue
        }
        const video = this.$refs['video' + i][0]
        // video.setAttribute('crossOrigin', '')
        video.currentTime = addedMaterialList[i].startFrame
        video.oncanplay = () => {
          if (!addedMaterialList[i]) {
            return false
          }
          if (
            video.src !== addedMaterialList[i].resourceUrl ||
            addedMaterialList[i].resourceIcon.indexOf('material1004') === -1
          ) {
            return false
          }
          canvas
            .getContext('2d')
            .drawImage(video, 0, 0, canvas.width, canvas.height)
          const dataURL = canvas.toDataURL('image/jpeg')
          addedMaterialList[i].resourceIcon =
            dataURL === black ? this.loadingImage : dataURL
          video.oncanplay = null
        }
      }
    },
    // 获取时长
    getDurationByWidth(width) {
      return width / 10
    },
    getReverseIndex(index, length) {
      return length - 1 + index + index * -2
    },
    updateStyle(before, after) {
      after.style.width = before.style.width
      after.style.height = before.style.height
      after.style.backgroundImage = before.style.backgroundImage
      after.style.backgroundSize = 'auto 100%'
    },
    updateTime(index, duration, operator) {
      const trackStartTime = this.selectedMaterialList[index].trackStartTime
      const trackEndTime = this.selectedMaterialList[index].trackEndTime
      if (operator) {
        this.selectedMaterialList[index].trackStartTime =
          (trackStartTime + duration).toFixed(1) * 1
        this.selectedMaterialList[index].trackEndTime =
          (trackEndTime + duration).toFixed(1) * 1
      } else {
        this.selectedMaterialList[index].trackStartTime =
          (trackStartTime - duration).toFixed(1) * 1
        this.selectedMaterialList[index].trackEndTime =
          (trackEndTime - duration).toFixed(1) * 1
      }
    },
    updateData(duration, isplaying) {
      let realDuration = duration
      if (duration < 0) {
        realDuration = 0
      }
      const left = realDuration * this.trackScale
      this.trackCurrentTime = formatDuration(realDuration)
      this.$store.commit('updatePointer', {
        pointerLeft: left,
        pointerDuration: realDuration
      })
      if (isplaying) {
        this.$refs.pointer.moveWhenVideoPlay(realDuration)
      } else {
        this.$refs.pointer.changePointerLeft(left)
      }
    },
    videoTimeUpdateMonitor(e) {
      let video = e.target
      if (!this.videoPlay) {
        return false
      }
      this.$refs.pointer.judgePlayingTarget()
      const trackStartTime = this.playingMaterial.trackStartTime
      const startTime = this.playingMaterial.startTime
      const lastMedia = this.selectedMaterialList[this.videoCount - 1]
      if (video.currentTime < startTime) {
        video.currentTime = startTime
      }
      const wholeTime = video.currentTime + trackStartTime - startTime
      const judgeTrackLast =
        Math.round(wholeTime) >= Math.round(lastMedia.trackEndTime)
      if (judgeTrackLast) {
        this.realLeft = 0
        // 最后一秒也要显示
        this.updateData(wholeTime, true)
        // 再从头开始
        this.updateData(0, true)
        video.currentTime = startTime
        setTimeout(() => {
          video.play()
        }, 150)
      } else {
        this.realLeft =
          (this.pointerDuration - trackStartTime) * this.trackScale
        this.updateData(wholeTime, true)
      }
    },
    keyUpMonitor(e) {
      this.keyCode = null
      // delete backspace删除选择块
      const deleteCode = e.keyCode === 46 || e.keyCode === 8
      // isInputting：输入框焦点状态 避免在输入框删除时误删选择块
      if (deleteCode && !this.isInputting && !this.isTextEdit && !this.isSaveOrSubmit && !this.isShowMaterialAdd) {
        switch (this.selected.type) {
          case 'selectedMaterialList':
            this.handleMediaDelete()
            break
          case 'videoTrackList':
            this.handleMediaDelete()
            break
          case 'pictureTrackList':
            this.$store.commit('updateDrrActive', null)
            this.$store.commit('trackBlockDelete', {
              trackId: 'pictureTrack',
              prefix: 'picture',
              vm: this
            })
            break
          case 'textTrackList':
            this.$store.commit('updateDrrActive', null)
            this.$store.commit('trackBlockDelete', {
              trackId: 'textTrack',
              prefix: 'text',
              vm: this
            })
            break
          case 'backImageTrackList':
            this.$store.commit('updateDrrActive', null)
            this.$store.commit('trackBlockDelete', {
              trackId: 'backImageTrack',
              prefix: 'backImage',
              vm: this
            })
            break
        }
      }
      // space控制播放
      if (
        e.keyCode === 32 &&
        this.isShowOnlineClip &&
        !this.isSaveOrSubmit &&
        !this.isShowMaterialAdd
      ) {
        this.handleVideoPlayOrPause()
      }
    },
    keyDownMonitor(e) {
      this.keyCode = e.keyCode
      // 阻止浏览器默认行为 - 空格滚动
      if (e.keyCode === 32) {
        e.preventDefault()
      }
    },
    mouseDownMonitor(e) {
      if (this.isSaveOrSubmit || this.isShowMaterialAdd) {
        return true
      }
      // 记录输入框焦点状态 避免在输入框删除时误删选择块
      this.isInputting = false
      const inputTarget = e.target.nodeName === 'INPUT'
      if (inputTarget) {
        this.isInputting = true
      }

      // 获取正在焦点的drr
      let drrTarget = null
      let name = null
      switch (this.activeName) {
        case 'picture':
          drrTarget = 'pictureDrr'
          name = 'picture'
          break
        case 'text':
          drrTarget = 'textDrr'
          name = 'text'
          break
      }
      // 无焦点的drr 不操作
      if (!drrTarget) {
        return true
      }
      // 在操作标签页区域操作时 保留句柄 激活drr, 否则取消drr激活状态
      const positionRect = this.$refs.tabsCol.$el.getBoundingClientRect()
      const inWidthRange = e.clientX > 0 && e.clientX < positionRect.width
      const inHeightRange =
        e.clientY > this.titleHeight &&
        e.clientY < positionRect.height + positionRect.top + this.titleHeight
      if ((inWidthRange && inHeightRange) || this.isTextEdit) {
        // 获取正在操作的drr
        const targetId = drrTarget + this.selected.trackIndex
        switch (name) {
          case 'picture':
            // 保留句柄
            const picDrr = this.$refs[drrTarget].find(item => {
              return item.$el.id === targetId
            })
            // 保留句柄
            picDrr.$refs.resizable[0].enabled = true
            // this.$refs[drrTarget][0].$refs.resizable[0].enabled = true
            break
          case 'text':
            const drr = this.$refs[drrTarget].find(item => {
              return item.$el.id === targetId
            })
            // 保留句柄
            drr.$refs.resizable[0].enabled = true
            break
        }
        this.$store.commit('updateDrrActive', name)
      } else {
        this.$store.commit('updateDrrActive', null)
      }
    },
    windowResizeMonitor() {
      if (this.isSaveOrSubmit) {
        return true
      }
      // 获取图标列表的宽度
      this.iconWidth = window.innerWidth * 0.04
      const frameWidth = this.$refs.videoFrame.clientWidth

      const proportion = this.videoFrame.width
        ? frameWidth / this.videoFrame.width
        : frameWidth / 1280
      this.videoFrame.width = frameWidth
      this.videoFrame.height = (frameWidth * 720) / 1280
      document.querySelector(
        '.online-clip-tabs .el-tabs__content'
      ).style.height = this.videoFrame.height + 'px'
      document.querySelector(
        '.online-clip-tabs .el-tabs__content'
      ).style.width = this.videoFrame.width + 'px'
      this.$refs.videoFrame.style.height = this.videoFrame.height + 'px'
      this.$refs.videoFrame.style.width = this.videoFrame.width + 'px'
      this.$store.commit('updateDrrResolution', {
        proportion: proportion,
        vm: this
      })
    },
    axisYScrollMonitor(e) {
      const top = e.target.scrollTop
      // 获得现在轨道区域总高度：字幕贴图轨道数*高度 + 视频轨道高度 + 暂未开发的音频轨高度
      const totalHeight =
        (this.textTrackList.length + this.pictureTrackList.length) * 40 +
        65 +
        40 +
        15
      // 如果目前已到底 不再允许下滑
      if (top + 200 >= totalHeight) {
        return false
      }
      this.$refs.timeAxis.$el.style.top = top + 'px'
      this.$refs.emptyIcon.style.top = top + 'px'
      this.$refs.pointer.handlePointerYStatic(e.target.scrollTop)
      this.$refs.clipResourceIcons.$el.style.top = -top + 'px'
    },
    stopCanvasVideo() {
      clearInterval(this.canvasTimer)
    },
    drawBackImage(arr) {
      let canvasBackImage = this.canvasBackImage
      let ctx = canvasBackImage.getContext('2d')
      if (arr[0].length) {
        const item = arr[0][0]
        const backImage = new Image()
        canvasBackImage.width = this.videoFrame.width
        canvasBackImage.height = this.videoFrame.height
        // console.log(this.videoFrame.width, canvasBackImage.width)
        this.$store.commit('setZoom', { width: this.videoFrame.width, height: this.videoFrame.height, realWidth: item.width, realHeight: item.height })
        backImage.onload = function () {
          ctx.drawImage(
            backImage,
            0,
            0,
            canvasBackImage.width,
            canvasBackImage.height
          )
        }
        backImage.src = item.resourceUrl // 设置
      } else {
        ctx.clearRect(0, 0, canvasBackImage.width, canvasBackImage.height)
      }
    },
    handleGoBack() {
      this.$confirm('页面内容未保存，确定要离开吗？', '提示', {
        confirmButtonText: '离开页面',
        cancelButtonText: '留在页面',
        center: true,
        type: 'warning'
      })
        .then(() => {
          this.handleAllClose()
          // this.$emit('go-back')
        }).catch(() => {
        })
    }
  },
  created() {
    this.fileList = materialStore.fileList
    this.isUploading = materialStore.isUploading
  },
  mounted() {
    window.addEventListener('keyup', this.keyUpMonitor)
    window.addEventListener('keydown', this.keyDownMonitor)
    window.addEventListener('mousedown', this.mouseDownMonitor)
    window.addEventListener('resize', this.windowResizeMonitor)
    this.$store.commit('initDragImage')
    this.$nextTick(() => {
      this.windowResizeMonitor()
      this.trackContainer = document.querySelector('.drag-target')
      this.pointerWidth = document.querySelector('.pointer').offsetWidth
      this.canvasVideo = this.$refs.canvasVideo
      this.canvasBackImage = this.$refs.canvasBackImage
      this.clipResource = this.$refs.clipResource.$el
      this.clipResource.addEventListener('scroll', this.axisYScrollMonitor)
    })
  },
  beforeDestroy() {
    clearInterval(this.canvasTimer)
    this.canvasTimer = null
    this.drawBackImage([[]])
    window.removeEventListener('keyup', this.keyUpMonitor)
    window.removeEventListener('keydown', this.keyDownMonitor)
    window.removeEventListener('mousedown', this.mouseDownMonitor)
    window.removeEventListener('resize', this.windowResizeMonitor)
    this.clipResource.removeEventListener('scroll', this.axisYScrollMonitor)
    if (this.videoTarget) {
      this.videoTarget.removeEventListener(
        'timeupdate',
        this.videoTimeUpdateMonitor
      )
    }
    // 处理点击菜单切换路由时，需要清空
    this.addedMaterialList = []
    this.$store.commit('clearAll')
  }
}
</script>
<style lang="stylus" scoped>
.online-clip
  background #fff
.search-tips
  margin-left 2px
  font-size 14px
  color #666
  vertical-align middle
  cursor default
  &:hover
    color #666
.dialog-header
  padding 10px
  letter-spacing 1px
  color #666
  background: #fff;
  border-bottom: 1px solid #eee;
  .dialog-header-title
    font-size 16px
    font-weight bolder
  .dialog-header-text
    font-size 13px
    padding-left 15px
.dialog-title
  display inline-block
  position relative
  height 40px
  margin-left 40px
  line-height 40px
  letter-spacing 1px
  font-size 17px
  font-weight 600
  color #333
  span
    display inline-block
    max-width 300px
    white-space nowrap
    overflow hidden
    text-overflow ellipsis
.dialog-input
  width 250px
.main-area
.operations-area
// .axis-area
//   min-width 1310px
.main-area
  margin-top 0px !important
  background #f2f2f2
  .material-area
    margin-top 0px
    height 100%
.diy-icon-t
  &:hover
    color #ff8b00
.lastest-info
  display inline-block
  position relative
  margin 5px 0
  width 170px
  border 2px solid #f2f2f2
  border-radius 3px
  background #ececec
  transition all .3s
  &:hover
    border-color #ff8b00
  video
    width 100%
    height 100px
    border-radius 3px 3px 0px 0px
    object-fit fill
    &:focus
      width 20px
.material-add, .material-delete
  position absolute
  top 3px
  font-size 17px
  color #fff
.material-add
  right 2px
.material-delete
  left 2px
  cursor pointer
  &:hover,
  &:focus
    color #ff8b00
.material-title
  padding 0px 2px 4px
  width 100%
  font-size 12px
  white-space nowrap
  overflow hidden
  text-overflow ellipsis
  cursor default
.methods-area
  position absolute
  bottom 5px
  // width 100%
  // background #f2f2f2
.methods-button-group
  display inline-block
  // margin 5px 2px 0px
// .methods-button
//   width 100px
//   height 30px
//   line-height 10px
//   font-size 13px
//   color #888
//   border 1px solid #777
//   &:focus
//     background #fff
//   &:hover
//     color #ff8b00
//     border-color #ff8b00
//     background #fff
.message
  font-size 12px
  color #ccc
  cursor default
  vertical-align middle
.location-upload
  display inline-block
  margin-left 8px
.methods-scan-way
  position absolute
  top 25px
  right 10px
  font-size 20px
  i
    margin-left 20px
.controls-duration
  display inline-block
  position absolute
  top 5px
  left 4vw
  font-size 14px
  color #ccc
.operations-area
  position relative
  // height 40px
  padding 18px
  border-bottom 2px solid #eee
  background #fff
.operations-convenient
  display inline-block
  position absolute
  bottom 8px
  left 18px
  // margin-left 15px
  vertical-align super
  i
    margin-right 20px
    font-size 20px
.icon-ban
  color #ccc
  cursor default
  &:hover,
  &:focus
    color #ccc
    cursor default
.operations-save
  position absolute
  bottom 6px
  right 18px
  font-size 13px
  color #888
  span
    vertical-align bottom
.save-my-works
  margin-left 10px
  width 140px
.save-clip
  margin-left 15px
  width 100px
.save-my-works, .save-clip
  font-size 14px
  color #fff
  border 0px
  background #ff8b00
.axis-area
  height 235px
  overflow hidden
.clip-resource-icons
  position relative
  text-align center
  font-size 17px
.empty-icon
  width 100%
  height 25px
  position relative
  background #FFFFFF
.ul-style
  position absolute
  left 4.16667% // 紧贴图标列表
  padding 10px
  width max-content
  text-align right
  font-size 14px
  border-radius 5px
  box-shadow 1px 1px 5px 1px #aaa
  background #fff
  z-index 6
  i:not(.el-icon-copy-document)
    width 28px
    text-align left
  li
    &:hover
      color #ff8b00
      cursor pointer
.track-type-icon
  display block
  height 40px
  line-height 40px
  &:hover,
  &:focus
    color inherit
    cursor default
.el-icon-video-camera
  height 65px
  line-height 65px
.material-container
  height 80%
  overflow-y scroll
.clip-resource
  position relative
  height 235px
  overflow auto
.pointer-style
  position relative
.time-axis
  margin-top 0px !important
  position relative
  z-index 2
.tracks-container
  overflow-x auto
.video-cols
  position relative
  padding 0px !important
  text-align center
.video-frame
  position relative
  width 100%
  background #fff
.video-controls
  position relative
  padding-top 5px
  width 100%
  background #000
.video-frame,
.video-controls
  // background #000
.canvas-video
  position absolute
  top 0px
  left 0px
  width 100%
  height 100%
  transform-origin 0 0
.resizable-container
  position absolute
  top 0px
  width 100%
  height 100%
  overflow hidden
.resizable-style
  position absolute
  z-index 2
  .el-image
  video
    width inherit
    height inherit
.picture-video
  object-fit fill
.video-track
  text-align left
.drag-target
  width 100%
  height 55px
.drag-ghost
  margin 0px
  height 40px
  video
    height 40px !important
.track-container
  display inline-block
.video-images
  display inline-block
  border-radius 5px
  cursor pointer
.editable-target
  height 55px
  video
    height 55px
</style>
<style lang="stylus" scoped>
.clip-resource
  >>>.el-row:not(.time-axis)
    margin-top 0px
    margin-bottom 10px
    height 30px
    background #f2f2f2
  .video-track
    position relative
    height 55px !important
// .online-clip-dialog
  // >>>.el-dialog
  //   margin-top 0vh !important
  //   height 100%
  //   border-radius 0px
  //   .el-dialog__header
  //     padding 5px
  //     height 40px
  //     line-height 40px
  //     font-size 16px
  //     font-weight 600
  //     border-radius 0px
  //     background #f2f2f2
  //   .el-dialog__body
  //     padding 0px 10px 0px 0px
  //     height calc(100vh - 70px)
  //     overflow-y scroll
.online-clip-tabs
  height 100%
  >>>.el-tabs__header
    margin 0px
    padding 0px 2px
    background #fff
    .el-tabs__item
      margin 0px 15px
      padding 0px
      font-weight 400
    .el-tabs__item.is-top:nth-child(2)
      padding-left 0px
    .el-tabs__item.is-top:last-child
      padding-right 0px
    .el-tabs__active-bar
      display none
>>>.el-tabs__header
  .el-tabs__nav-wrap::after
    height 0px
.online-clip-dialog
  >>>.el-tabs__content
    // padding 10px
    height 80%
    overflow inherit
    .el-tab-pane
      position relative
      height 100%
>>>.el-row
  margin 0px
  margin-top 10px
i
  cursor pointer
  &:hover,
  &:focus
    color #ff8b00
.controls-icons
  >>>.el-image
    width 18px
    height 18px
    cursor pointer
>>>.el-dialog__body::-webkit-scrollbar
  width 5px
  height 5px
>>>.el-dialog__body::-webkit-scrollbar-thumb
  border-radius 5px
  background-color #ccc
::-webkit-scrollbar
  width 5px
  height 5px
::-webkit-scrollbar-thumb
  border-radius 5px
  background-color #ccc
.el-dialog__wrapper
  overflow hidden
.add-material-dialog
  overflow-y auto
.canvas-back-img
  position absolute
  top 0px
  left 0px
  width 100%
  height 100%
  transform-origin 0 0
.empty-text
  height 20vh
  line-height 20vh
  font-size 13px
  text-align center
  color #aaa
.material-cols
  border-right 1px solid #eee
</style>
